import React, { Fragment, useState } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { ConfirmationModal } from "../../../layout/Modal/ConfirmationModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { cancelOrder as cancelOrderApi } from "../../../../api/orders/orders";
import { Link } from "react-router-dom";
import { NOTIFICATION_ORDER_ACTIONS } from '../../../../config/notifications';
import { ORDER_STATUSES } from '../../../../config/constants';
import { store } from '../../../../store/store';
import { hideNotification } from '../../../../store/actions/notification';

function CancelOrder(props) {
  const [showCancelOrderModal, setCancelOrderModal] = useState(false);
  const {index, order, showIcon} = props;

  if (order.status !== ORDER_STATUSES.INITIATED) {
    return null;
  }

  const cancelOrder = () => {
    cancelOrderApi({
      orderId: order.id,
      notificationId: NOTIFICATION_ORDER_ACTIONS,
    }).then((response) => {
      setCancelOrderModal( false );
      if (response.status === 200) {
        props.actionCallback( true );
      }
    });
  };

  return (<Fragment>
      {!showIcon ?
        <Fragment>
          <Button
            color="primary"
            size="sm"
            className="btn-warning"
            type="button"
            id={`cancel-order-icon-${index}`}
            onClick={(e) => {
              e.target.blur();
              store.dispatch(hideNotification());
              setCancelOrderModal(true)
            }}
          >
            <FormattedMessage
              id="components.pages.orders.table.actionButtons.cancel_order"/>
          </Button>
          <UncontrolledTooltip
            delay={0}
            target={`cancel-order-icon-${index}`}
            modifiers={{
              preventOverflow: {
                enabled: true,
                boundariesElement: "body",
              },
            }}
          >
            <FormattedMessage
              id="components.pages.orders.table.actionButtons.cancel_order"/>
          </UncontrolledTooltip>
        </Fragment> :
        <Fragment>
          <Link
            to="#"
            className="cursor-pointer px-2 mx-2 link-icon-color"
            id={`cancel-order-icon-` + props.index}
            onClick={(e) => {
              e.target.blur();
              setCancelOrderModal(true)
            }}
          >
            <FontAwesomeIcon
              size="lg"
              className="cursor-pointer"
              pointerEvents="none"
              icon={faTimes}
            />
          </Link>
          <UncontrolledTooltip
            delay={0}
            target={`cancel-order-icon-${props.index}`}
            modifiers={
              {
                preventOverflow: {
                  enabled: true,
                  boundariesElement: 'body'
                }
              }
            }
          >
            <FormattedMessage
              id="components.pages.orders.table.actionButtons.cancel_order"/>
          </UncontrolledTooltip>
        </Fragment>
      }

      <ConfirmationModal
        showModal={showCancelOrderModal}
        closeModal={() => setCancelOrderModal(false)}
        confirmationYes={cancelOrder}
        messageId="components.layout.confirmation.body.confirm_cancel_order"
      />
    </Fragment>
  );
}

export { CancelOrder };
